/**
 * Shared CRM utilities.
 */

import { createCRMObjectClient } from './CRMObjectClient';

/**
 * UUID v4 pattern — matches timeline_id format.
 * Shared across query factories and store hooks.
 */
export const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Fetch the latest `last_event_seq` for an entity before submitting events.
 *
 * The settings pages (teams, pipelines) need a fresh seq to avoid
 * stale-sequence conflicts when the React Query cache is out-of-date.
 * This helper consolidates the repeated
 * `createCRMObjectClient(…).getByEntityId(…) → obj.last_event_seq` pattern
 * into a single call-site.
 */
export async function fetchFreshSeq(
  orgId: number,
  entityTypeName: string,
  entityId: string
): Promise<number> {
  const obj = await createCRMObjectClient(orgId, entityTypeName).getByEntityId(
    entityId
  );
  return obj.last_event_seq;
}
